// src/utils/chunkErrorHandler.js
//
// Every deploy changes the hashed filenames of code-split chunks. A browser
// tab left open from before a deploy still references the old filenames,
// which no longer exist on the server once the new build replaces them -
// this surfaces to the user as "Loading chunk X failed" (or Safari/Firefox's
// "error loading dynamically imported module"). Since we deploy most
// weekends, this is expected to recur; the fix is a one-time silent reload
// to pick up the new build instead of showing a scary error popup.

const RELOAD_FLAG_KEY = 'lm_chunkErrorReloaded';

export function isChunkLoadError(error) {
  const message = (error && error.message) || String(error || '');
  const name = (error && error.name) || '';
  return (
    /Loading chunk [\w.-]+ failed/i.test(message) ||
    /ChunkLoadError/i.test(name) ||
    /ChunkLoadError/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message)
  );
}

// If `error` looks like a stale-chunk failure, reloads the page once per
// tab session and returns true (caller should stop and skip its own error
// handling). Returns false for anything else, or if we already tried
// reloading once this session (avoids a reload loop if it's not actually a
// stale-build problem).
export function reloadIfChunkError(error) {
  if (!isChunkLoadError(error)) return false;

  try {
    if (sessionStorage.getItem(RELOAD_FLAG_KEY)) return false;
    sessionStorage.setItem(RELOAD_FLAG_KEY, '1');
  } catch (e) {
    // sessionStorage unavailable (private browsing etc.) - fall through and
    // reload anyway rather than showing the confusing error.
  }

  window.location.reload();
  return true;
}
